"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.META_TYPE = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _head = _interopRequireDefault(require("next/head"));
var _router = require("next/router");
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _LanguageProvider = require("@deosite/api/hooks/common/LanguageProvider");
var _useSalesmanago = _interopRequireDefault(require("@deosite/api/hooks/REST/useSalesmanago"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var META_TYPE = {
  searchResults: "product-search",
  productPage: "product-page",
  categoryPage: "category-page, product-list"
};
exports.META_TYPE = META_TYPE;
Object.freeze(META_TYPE);
var defaultProps = {
  siteName: "Dajar"
};
var MetaTags = function MetaTags(props) {
  var page = props.page,
    sku = props.sku,
    passedUrl = props.url,
    productRegularPrice = props.productRegularPrice,
    productSpecialPrice = props.productSpecialPrice,
    productAvailability = props.productAvailability,
    productBrand = props.productBrand,
    productCategory = props.productCategory,
    currentPageNumber = props.currentPageNumber,
    tags = props.tags,
    noFollow = props.noFollow,
    domains = props.domains,
    _props$siteName = props.siteName,
    siteName = _props$siteName === void 0 ? defaultProps.siteName : _props$siteName;
  var translations = {
    page: (0, _langLibrary["default"])("page")
  };
  var singleDomain = props.singleDomain,
    title = props.title,
    description = props.description,
    imageUrl = props.imageUrl;
  var handleSalesmanagoEvent = (0, _useSalesmanago["default"])();
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  singleDomain = singleDomain ? "https://".concat(singleDomain) : null;
  var baseUrl = domains ? "https://".concat(Object.keys(domains).find(function (domain) {
    return domains[domain] === language.language;
  })) : singleDomain;
  var router = (0, _router.useRouter)();
  var routePaths = router !== null && router !== void 0 && router.asPath ? router.asPath.split("?") : [];
  var defaultOgImage = "/static/images/dajar-og-image.jpg";
  if (currentPageNumber) {
    title += "| ".concat(translations.page, " ").concat(currentPageNumber);
  }
  var tagsPrefix = tags && tags.length > 3 ? tags.join(", ") + "... - " : tags && tags.length > 0 ? tags.join(", ") + " - " : "";
  title = tagsPrefix + title;
  description = tagsPrefix + description;
  var url = noFollow ? baseUrl + passedUrl : baseUrl + "".concat(routePaths[0]);
  imageUrl = imageUrl === undefined || page === META_TYPE.searchResults ? baseUrl + defaultOgImage : baseUrl + imageUrl;
  (0, _react.useEffect)(function () {
    handleSalesmanagoEvent("VISIT");
  }, [title]);
  if (title !== "undefined") {
    return __jsx(_head["default"], null, __jsx("title", null, title), __jsx("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1.0"
    }), __jsx("meta", {
      name: "robots",
      content: page === META_TYPE.searchResults || noFollow ? "noindex, nofollow" : "index, follow"
    }), __jsx("link", {
      rel: "canonical",
      href: url
    }), __jsx("meta", {
      name: "title",
      content: title
    }), __jsx("meta", {
      name: "description",
      content: description
    }), __jsx("meta", {
      property: "og:site_name",
      content: siteName
    }), __jsx("meta", {
      property: "og:locale",
      content: language === null || language === void 0 ? void 0 : language.language
    }), __jsx("meta", {
      property: "og:title",
      content: title
    }), __jsx("meta", {
      property: "og:description",
      content: description
    }), __jsx("meta", {
      property: "og:type",
      content: page === META_TYPE.productPage ? "product" : "website"
    }), __jsx("meta", {
      property: "og:url",
      content: url
    }), __jsx("meta", {
      property: "og:image",
      content: imageUrl
    }), __jsx("meta", {
      property: "og:image:alt",
      content: title
    }), page === META_TYPE.productPage && __jsx(_react["default"].Fragment, null, __jsx("meta", {
      property: "product:condition",
      content: "new"
    }), __jsx("meta", {
      property: "product:availability",
      content: productAvailability
    }), __jsx("meta", {
      property: "product:original_price:amount",
      content: productRegularPrice
    }), __jsx("meta", {
      property: "product:original_price:currency",
      content: "PLN"
    }), __jsx("meta", {
      property: "product:price:amount",
      content: productSpecialPrice
    }), __jsx("meta", {
      property: "product:price:currency",
      content: "PLN"
    }), __jsx("meta", {
      property: "product:retailer_item_id",
      content: sku
    }), __jsx("meta", {
      property: "product:brand",
      content: productBrand
    }), __jsx("meta", {
      property: "product:category",
      content: productCategory
    })), __jsx("meta", {
      property: "twitter:card",
      content: page === META_TYPE.productPage ? "product" : "summary_large_image"
    }), __jsx("meta", {
      property: "twitter:site",
      content: "@DAJARpl"
    }), __jsx("meta", {
      property: "twitter:url",
      content: url
    }), __jsx("meta", {
      property: "twitter:title",
      content: title
    }), __jsx("meta", {
      property: "twitter:description",
      content: description.slice(0, 100)
    }), __jsx("meta", {
      property: "twitter:image",
      content: imageUrl
    }));
  } else {
    return __jsx(_head["default"], null);
  }
};
var _default = MetaTags;
exports["default"] = _default;